(function(angular){
	'use strict';
	
	var planBarsObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			planName: '<',
			darkTheme: '@?'
		},
		controller: [PlanBarsFunction],
		controllerAs: 'planBars'
	};
	
	angular
		.module('planModule')
		.component('planBars', planBarsObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/shared/plans/plan-bars.html';
	}
	
	function PlanBarsFunction(){
		var planBars = this;

		planBars.$onInit = function() {
			var bars = {
				'Supplemental Income': {
					dividends: '100%',
					appreciation: '33%',
					totalReturn: '66%'
				}, 
				'Balanced Investing': {
					dividends: '66%',
					appreciation: '66%',
					totalReturn: '83%'
				},
				'Long-Term Growth': {
					dividends: '33%',
					appreciation: '100%',
					totalReturn: '100%'
				}
			};

			planBars.plan = bars[planBars.planName];
		};
	}
})(window.angular);